import SwiperCore, { Autoplay, Pagination } from 'swiper'
import type { Swiper } from 'swiper/vue'

import 'swiper/css'
import 'swiper/css/pagination'

export function setSwiperColor(name: string, color: string) {
  document.documentElement.style.setProperty(`--swiper-${name}-color`, color)
}

export type SwiperProps = InstanceType<typeof Swiper>['$props']

export const defaultSwiperProps: SwiperProps = {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 16,
  autoplay: {
    pauseOnMouseEnter: true,
    disableOnInteraction: true,
    delay: 5000,
  },
  pagination: {
    clickable: true,
    type: 'bullets',
  },
}

export default defineNuxtPlugin(() => {
  SwiperCore.use([Autoplay, Pagination])

  const { colors } = useTheme()

  setSwiperColor('theme', colors.white)
  setSwiperColor('pagination-bullet-inactive', colors.bluish)
})
